import React from 'react';
import { Trans } from 'react-i18next';
import TextTooltipContent from '../../../Popover/_partials/TextTooltipContent';
import Button from '../../../Button';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';
import s from './PortfolioTooltip.scss';
var PortfolioTooltip = function (_a) {
    var className = _a.className, referenceElement = _a.referenceElement, onDismiss = _a.onDismiss;
    return (React.createElement(SimplePopperPopover, { className: className, referenceElement: referenceElement, placement: "bottom", secondaryPlacement: "end", showArrow: true, popoverContent: React.createElement(TextTooltipContent, { textClassName: s['text'], tooltipText: 
            /* prettier-ignore */
            React.createElement(Trans, { i18nKey: "siteHeader.userMenu.wixPortfolio.tooltip" },
                "Next time you want to create a portfolio you'll find it here",
                React.createElement(Button, { view: "b34", onClick: onDismiss, className: s['dismiss-btn'] }, "Got it")) }) }));
};
PortfolioTooltip.displayName = 'PortfolioTooltip';
export default PortfolioTooltip;
//# sourceMappingURL=PortfolioTooltip.js.map